import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
  PAYMENT_TYPE,
  QuotationNewModelDto,
} from '@savgroup-front-common/types';
import { QuoteClientAnswer } from '@savgroup-front-common/types/Quotation/QuoteClientAnswer';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.repairer}quotes/answered`;

interface SetQuoteClientAnswerCommandArgs {
  quoteId: string;
  clientAnswer: QuoteClientAnswer;
  paymentType?: PAYMENT_TYPE;
  rejectReason?: string;
}

export const setQuoteClientAnswerCommand = async ({
  quoteId,
  clientAnswer,
  paymentType,
  rejectReason,
}: SetQuoteClientAnswerCommandArgs): Promise<
  BackResponseFailure | BackResponse<QuotationNewModelDto[]>
> => {
  try {
    return await apiCall<BackResponse<QuotationNewModelDto[]>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        quoteId,
        clientAnswer,
        paymentType,
        rejectReason,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
